import OrgRemediationSettingsPanel from '../components/OrgRemediationSettings'

export default function RemediationSettings() {
  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="text-display-md" style={{ margin: 0 }}>Remediation</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-muted)', fontSize: '13px' }}>
            Give the automated code-fix agent context about your stack so it fixes incidents correctly.
          </p>
        </div>
      </div>

      <OrgRemediationSettingsPanel />
    </div>
  )
}
